import { navigate } from "@reach/router"
import React, { useCallback, useEffect, useState } from "react"
import { createContext, useContext } from "react"
import {
  accountDetail,
  billingRearrange,
  calculateInternetSpeed,
  serviceRearrange,
} from "../helpers/helper"
import { useAuth } from "../hooks/useAuth"
import { getHeaderAccessToken } from "../services/auth"
import {
  getServiceDetails,
  getCustomerDetails,
  getBillingDetails,
  getCustomerDetailsTaas,
  getServiceDetailsTaas,
} from "../services/userDetails.service"
import { BillingDetails } from "../types/billingDetails.type"
import {
  BillingAccount,
  CustomerAccount,
  CustomerAccountTaas,
  CustomerDetails,
  RearrangedCustomerAccount,
  RearrangedCustomerAccountTaas,
  CustomerAccountcomposit
} from "../types/customerDetails.type"
import { RearrangedServiceAccountTaas, SelectedServiceAccount, SelectedServiceAccountTaas, ServiceAccount, ServiceAccountTaas, ServiceDetails, ServiceDetailsTaas } from "../types/serviceDetails.type"
import http from "../utils/http"
import { initializeServiceAccount } from "../utils/initializer"
import { TokenDetails, TaasTokenDetails, useAuthContext, UserDetails } from "./AuthContext"
import { useLoadingData } from "./LoadingContext"
import { contactRetrieve } from "../services/createTicket.service"
import Cookies from "js-cookie"

type IContext = {
  customerDetails: CustomerDetails | undefined
  billingDetails: BillingDetails | undefined
  serviceDetails: ServiceDetails | undefined
  serviceAccounts: (RearrangedCustomerAccount | undefined)[] | undefined
  customerAccountTaas?: CustomerAccountTaas[] 
  serviceDetailsTaas?: RearrangedServiceAccountTaas[]
  selectedServiceAccountTaas?: SelectedServiceAccountTaas

  npsSurvey: boolean
  customerAcc: CustomerAccount[] | undefined
  internetSpeed: number
  promisedSpeed: number
  handleSetSelectedServiceAccountTaas: (customer: CustomerAccountTaas, account: ServiceAccountTaas)=>void,
  handleCustomerDetails: (customerDetails: CustomerDetails) => void
  handleServiceDetails: (serviceDetails: ServiceDetails) => void
  handleSubmitNPSSurvey: () => void
  setNpsData: (rqUuid: string) => void
  setRefetchDetails: (refetch: boolean) => void
}

const UserDetailsContext = createContext<IContext>({
  selectedServiceAccountTaas: undefined,

  customerDetails: undefined,
  billingDetails: undefined,
  serviceDetails: undefined,
  serviceAccounts: undefined,
  npsSurvey: false,
  customerAcc: undefined,
  customerAccountTaas: undefined,
  serviceDetailsTaas: undefined,
  internetSpeed: 0,
  promisedSpeed: 0,
  handleSetSelectedServiceAccountTaas:(customer: CustomerAccountTaas, service: ServiceAccountTaas)=>{},
  handleCustomerDetails: (customerDetails: CustomerDetails) => {},
  handleServiceDetails: (serviceDetails: ServiceDetails) => {},
  handleSubmitNPSSurvey: () => {},
  setNpsData: (rqUuid: string) => {},
  setRefetchDetails: (refetch: boolean) => {},
})

export const useUserDetails = () => useContext(UserDetailsContext)

type UserProviderProps = {
  children: React.ReactNode
}

export const UserDetailsProvider: React.FC<UserProviderProps> = ({
  children,
}) => {
  const { header_access_token, tokenDetails, updateTokenDetails, header_tass_token, taasTokenDetails, updateTassDetails, logout, userInfo } =
    useAuthContext()
  const { setLoading } = useLoadingData()
  const [npsSurvey, setNpsSurvey] = useState<boolean>(false)
  const [refetchDetails, setRefetchDetails] = useState<boolean>()
  const [internetSpeed, setInternetSpeed] = useState<number>(0)
  const [promisedSpeed, setPromisedSpeed] = useState<number>(0)
  const [customerDetails, setCustomerDetails] = useState<
    CustomerDetails | undefined
  >()
  const [customerAcc, setCustomerAcc] = useState<
    CustomerAccount[]
  >()
  const [billingDetails, setBillingDetails] = useState<
    BillingDetails
  >()
  const [serviceDetails, setServiceDetails] = useState<
    ServiceDetails
  >()
  const [serviceAccounts, setServiceAccounts] = useState<
    (RearrangedCustomerAccount | undefined )[] 
  >()

  // ---------- TAAS --------------

  const [customerAccountTaas, setCustomerAccountTaas] = useState<
    CustomerAccountTaas[]
  >()

  const [serviceDetailsTaas, setServiceDetailsTaas] = useState<
    RearrangedServiceAccountTaas[]
  >()


  // ------------------------------
  const [npsData, setNpsData] = useState("")

  const handleSetInternetSpeed = (speed:number)=>{
    setInternetSpeed(speed)
  }
  const handleSetPromisedSpeed = (speed:number)=>{
    setPromisedSpeed(speed)
  }

  const [selectedServiceAccountTaas, setSelectedServiceAccountTaas] = useState<SelectedServiceAccountTaas>()
  const handleSetSelectedServiceAccountTaas = (customer: CustomerAccountTaas,account: ServiceAccountTaas)=>{
    setSelectedServiceAccountTaas({
      CustomerAccount: customer,
      ServiceAccount: account
    })
  }
  const [selectedServiceAccount, setSelectedServiceAccount] = useState<SelectedServiceAccount>()
  const handleSetSelectedServiceAccount = (customer: CustomerAccount,account: ServiceAccount)=>{
    setSelectedServiceAccount({
      CustomerAccount: customer,
      ServiceAccount: account
    })
  }

  const handleCustomerDetails = (customerDetails: CustomerDetails) => {
    setCustomerDetails(customerDetails)
  }

  const handleServiceDetails = (serviceDetails: ServiceDetails) => {
    setServiceDetails(serviceDetails)
  }

  const handleSetNPSSurvey = () => {
    const survey = Cookies.get("npsSurvey")
    if (survey && survey === "true") {
      setNpsSurvey(true)
    } else {
      setNpsSurvey(false)
    }
  }

  const handleSubmitNPSSurvey = () => {
    Cookies.set("npsSurvey", "true")
    setNpsSurvey(true)
  }

  useEffect(() => {
    handleSetNPSSurvey()
  }, [npsSurvey])


  // const getCustomerDetailsInfo = async(access_token:string)=>{
  //   const response = await getCustomerDetails(access_token)
  //   if (
  //     response.status &&
  //     response.status.errors[0].code === "MS_UTL_006"
  //   ) {
  //     setLoading(false, "")
  //     navigate("/app/profile-incomplete")
  //     return
  //   }
  //   let accounts = response.Response.CustomerAccounts

  //   const filteredAccounts = accounts.filter(
  //     item =>
  //       item.SystemName !== "ZSMART" && item.SystemName !== "STELLAR"
  //   )
  //   // if (
  //   //   filteredItems.length === 1 &&
  //   //   filteredItems[0].BillingAccounts.length === 0
  //   // ) {
  //   //   return 401;
  //   // }
  //   let accountInfo: RearrangedCustomerAccount[] = []
  //   setCustomerAcc(filteredAccounts)
  //   filteredAccounts.map(account => {
  //     account.BillingAccounts.forEach(billingAccount => {
  //       let customerInfo
  //       let arrayAccountInfo

  //       customerInfo = {
  //         idType: account.TMPrimaryCustomerIDType,
  //         idNumber: account.TMCustomerIDNumber,
  //         name: account.Name,
  //         phone: account.TMContactCellPhone,
  //       }
  //       arrayAccountInfo = {
  //         customerInfo: customerInfo,
  //         accountLabel: billingAccount.AccountLabel,
  //         accountNumber: billingAccount.AccountNumber,
  //         accountStatus: billingAccount.AccountStatus,
  //         billingName: billingAccount.BillingName,
  //         systemName: account.SystemName,
  //         latestBilling: {},
  //         creditUtilization: {},
  //         latestDueUnbilledUsage: {
  //           OutstandingAmount: "RM -.--",
  //         },
  //         serviceAccount: [],
  //       }
  //       accountInfo.push(arrayAccountInfo)
  //     })
  //   })
  //   let finalAccountDetails = accountDetail(accountInfo, filteredAccounts)
  //   let arrangedCA: RearrangedCustomerAccount[] = []
  //   await Promise.all(
  //     finalAccountDetails.map(async customerAccount => {
  //       const bodyRequest = {
  //         BillingAccountNo:
  //           customerAccount && customerAccount.encryptedAccountNumber,
  //         SystemName: customerAccount && customerAccount.systemName,
  //       }
  //       const apiResponse =
  //         access_token &&
  //         (await getBillingDetails(
  //           access_token,
  //           bodyRequest
  //         ))
  //       let arrangedBA
  //       if (customerAccount && customerAccount.uca && apiResponse) {
  //         arrangedBA = await billingRearrange(
  //           apiResponse.Response,
  //           customerAccount.uca
  //         )
  //         arrangedCA.push(arrangedBA)
  //       }
  //     })
  //   )
  //   finalAccountDetails = accountDetail(arrangedCA, filteredAccounts)
  //   let counter = 0
  //   const serviceAccountData = await Promise.all(
  //     finalAccountDetails.map(async (ca, index) => {
  //       let arrangedSA

  //       const bodyRequest = {
  //         BillingAccountNo: ca && ca.encryptedAccountNumber,
  //         SystemName: ca && ca.systemName,
  //       }

  //       if (access_token) {
  //         const apiResponse = await getServiceDetails(
  //           access_token,
  //           bodyRequest
  //         )
  //         if (apiResponse.Status.Code !== 200) {
  //           counter += 1
  //           if (counter === finalAccountDetails.length) {
  //             throw "All accounts are invalid"
  //           }
  //           if (ca) {
  //             ca.uca.serviceAccount = [
  //               { ...initializeServiceAccount(), errorAccount: true },
  //             ]
  //             return ca.uca
  //           }
  //         }
  //         if (ca && apiResponse)
  //           arrangedSA = await serviceRearrange(
  //             apiResponse.Response,
  //             ca.uca
  //           )
  //       }

  //       return arrangedSA
  //     })
  //   )
  //   const NOVAaccounts: RearrangedCustomerAccount[] = []
  //   const ICPAccounts: RearrangedCustomerAccount[] = []
  //   serviceAccountData.forEach(serviceAccount => {
  //     if (serviceAccount?.systemName === "ICP") {
  //       ICPAccounts.push(serviceAccount)
  //     } else if (serviceAccount?.systemName === "NOVA") {
  //       NOVAaccounts.push(serviceAccount)
  //     }
  //   })
  //   const sortedServiceAccountDetails = [...NOVAaccounts, ...ICPAccounts]

  //   setCustomerDetails(response.Response)
  //   if (serviceAccountData) {
  //     setServiceAccounts(sortedServiceAccountDetails)
  //     const internetSpeed = calculateInternetSpeed(
  //       serviceAccountData[0]?.serviceAccount[0].ProdPromName
  //     )
  //     setInternetSpeed(internetSpeed)
  //     setPromisedSpeed(internetSpeed * 0.9)
  //     navigate("/app/auto")
  //   }
  // }

  const getCustomerDetailsInfoTaas = async (tass_token:string, userInfo:any, access_token:string)=>{
    const randomstring = await randomString(16, true, true, true, false);
    
    const customerDetailsTaasencrypt= await getCustomerDetailsTaas(tass_token, userInfo, randomstring);
    const customerDetailsTaas = JSON.parse(customerDetailsTaasencrypt);
    if ( customerDetailsTaas.status && customerDetailsTaas.status.errors[0].code === "MS_UTL_006" ) {
          setLoading(false, "")
          navigate("/app/profile-incomplete")
          return
        }
    const filteredCustomerAccounts = customerDetailsTaas.Response.CustomerAccounts
    const filteredcompositAccounts:any = [];
    const filteredAccounts:any = filteredCustomerAccounts.filter(
      (item: any) =>
        item.SystemName == "NOVA" || item.SystemName == "ICP"
    )
    const filteredTaasAccounts:any = filteredCustomerAccounts.filter(
      (item: any) =>
        item.SystemName == "TaaS"
    )
    if (
      filteredAccounts.length > 0
    ) {

      const customerDet:any = await getCustomerDetails(access_token);

      if(customerDet.Response.CustomerAccounts){
      const encryptedAccountDetails = customerDet.Response.CustomerAccounts;
      
        const updatedResponse1 = await mergedAccount(filteredAccounts, encryptedAccountDetails);

    updatedResponse1.map((account: any) => {
        const accountInfo: any = [];
        account.BillingAccounts.forEach((billingAccount:any) => {
          let customerInfo
          let arrayAccountInfo
  
          customerInfo = {
            idType: account.TMPrimaryCustomerIDType,
            idNumber: account.TMCustomerIDNumber,
            name: account.Name,
            phone: account.TMContactCellPhone,
            EncryptedAccountNo: account.EncryptedAccountNo,
            EncryptedName: account.EncryptedName,
            EncryptedCustomerIdNumber: account.EncryptedCustomerIdNumber,
            AccountNo: account.AccountNo,
          }
          arrayAccountInfo = {
            customerInfo: customerInfo,
            accountLabel: billingAccount.AccountLabel,
            accountNumber: billingAccount.AccountNumber,
            accountStatus: billingAccount.AccountStatus,
            billingName: billingAccount.BillingName,
            systemName: account.SystemName,
            CustomerRowId: billingAccount.AccountNumber,
            latestBilling: {},
            creditUtilization: {},
            latestDueUnbilledUsage: {
              OutstandingAmount: "RM -.--",
            },
            serviceAccount: [],
          }
          accountInfo.push(arrayAccountInfo);
          filteredcompositAccounts.push(arrayAccountInfo);
        })
      })
      }
      
     
    
     // let finalAccountDetails = accountDetail(accountInfo, filteredAccounts);
      //filteredcompositAccounts.push(finalAccountDetails);
      
    }
    if(filteredTaasAccounts.length >0){
      
      filteredTaasAccounts.map((account: any) => {
        const accountInfoTaas: any = [];
          let customerInfo
          let arrayAccountInfo
  
          customerInfo = {
            idType: account.TMPrimaryCustomerIDType,
            idNumber: account.TMCustomerIDNumber,
            name: account.Name,
            phone: '',
            EncryptedAccountNo: '',
            EncryptedName: account.Name,
            AccountNo: "",
          }
          arrayAccountInfo = {
            customerInfo: customerInfo,
            accountLabel: '',
            accountNumber: '',
            accountStatus: 'Active',
            billingName: '',
            systemName: account.SystemName,
            CustomerRowId: account.CustomerRowId,
            latestBilling: {},
            creditUtilization: {},
            latestDueUnbilledUsage: {
              OutstandingAmount: "RM -.--",
            },
            serviceAccount: [],
          }
          accountInfoTaas.push(arrayAccountInfo)
          filteredcompositAccounts.push(arrayAccountInfo);
      })
      //let finalAccountDetailsTaas = accountDetail(accountInfoTaas, filteredTaasAccounts);
      //filteredcompositAccounts.push(accountInfoTaas);

      
    }

    setCustomerAccountTaas(filteredCustomerAccounts)
    let counter = 0;
    let filledServiceDetails: RearrangedServiceAccountTaas[] = [];
    const serviceAccountDataTaas =  await Promise.all(filteredcompositAccounts.map(async (account:any)=>{

      let formatted = userInfo.national_id_number.slice(0, 6) + '-' + userInfo.national_id_number.slice(6, 8) + '-' + userInfo.national_id_number.slice(8);
      let body: any = [];
 
      if(account.accountNumber != ""){
         body =  {
          idType : "New NRIC",
          idValue : formatted,
          SystemName: account.systemName,
          BillingAccountNo: account.accountNumber
        };
      } else {
        body =  {
          idType : "New NRIC",
          idValue : formatted,
          SystemName: account.systemName
        };
      }
      
        const ServiceAccountsTaas = await  getServiceDetailsTaas(tass_token,body,randomstring)

      if(ServiceAccountsTaas.Response.ServiceAccount){
        const filteredServiceAccountsTaas = ServiceAccountsTaas.Response.ServiceAccount
        const mappedServiceAccounts: any = filteredServiceAccountsTaas.map((details:any)=>({
          CustomerAccount: account,
          ServiceDetails: details
        }))
        filledServiceDetails.push(...mappedServiceAccounts);
      } else {
        console.log("not working");
      }
    }))

    setServiceDetailsTaas(filledServiceDetails);
    navigate("/app/auto")
  }
  const randomString = async (length:any, includeLowercase = true, includeUppercase = true, includeNumbers = true, includeSpecial = false) =>  {
    let characters = '';
    
    if (includeLowercase) characters += 'abcdefghijklmnopqrstuvwxyz';
    if (includeUppercase) characters += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    if (includeNumbers) characters += '0123456789';
    if (includeSpecial) characters += '!@#$%^&*()_+[]{}|;:,.<>?';
  
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }
const mergedAccount = async(account1:any, account2:any) =>{

  account1.forEach((nova:any) => {
    // Find a matching BillingAccount in response2
    const matchingAccount = account2.find((oldNova:any) => oldNova.AccountNo === nova.AccountNo);
    // If a match is found, merge the data
    if (matchingAccount) {
        // Example of merging specific data from response2 to response1
        nova.EncryptedAccountNo = matchingAccount.EncryptedAccountNo; // Merging EncryptedAccountNumber
        nova.EncryptedName = matchingAccount.EncryptedName || nova.Name; 
        nova.EncryptedCustomerIdNumber= matchingAccount.EncryptedCustomerIdNumber || nova.EncryptedCustomerIdNumber;// Merging AutopayRequestHistory
    }
});
return account1;
}

  useEffect(() => {
    const fetchDetails = async () => {
      if (taasTokenDetails?.access_token != null && tokenDetails?.access_token != undefined) {
        setLoading(true, "Just a second while we retrieve your information")
        try {
          // Remove to test taas 16/11/2024//
          //await getCustomerDetailsInfo(tokenDetails.access_token)

          // Taas Integration
          
          await getCustomerDetailsInfoTaas(taasTokenDetails?.access_token, userInfo, tokenDetails.access_token)

        } catch (error) {
          setLoading(false, "")
          logout()
          navigate("/app/error")
        }

        setLoading(false, "")
      }
    }
    fetchDetails()
  }, [tokenDetails, taasTokenDetails, refetchDetails])

  const context = React.useMemo(
    () => ({
      customerDetails,
      billingDetails,
      serviceDetails,
      serviceAccounts,
      customerAccountTaas,
      serviceDetailsTaas,
      npsSurvey,
      customerAcc,
      internetSpeed,
      promisedSpeed,
      selectedServiceAccountTaas,
      handleSetSelectedServiceAccountTaas,
      setNpsData,
      handleServiceDetails,
      handleCustomerDetails,
      handleSubmitNPSSurvey,
      setRefetchDetails,
    }),
    [
      header_access_token,
      header_tass_token,
      customerDetails,
      billingDetails,
      serviceDetails,
      serviceAccounts,
      npsSurvey,
      internetSpeed,
      promisedSpeed,
      customerAcc,
      customerAccountTaas,
      serviceDetailsTaas,
      selectedServiceAccountTaas,
      handleSetSelectedServiceAccountTaas,
      setNpsData,
      handleSubmitNPSSurvey,
      handleServiceDetails,
      handleCustomerDetails,
      handleSubmitNPSSurvey,
      setRefetchDetails,
    ]
  )
  return (
    <UserDetailsContext.Provider value={context}>
      {children}
    </UserDetailsContext.Provider>
  )
}
